export interface StreamLinkStyles {
  borderRadius: string;
  height: string;
  paddingX: string;
  gap: string;
  textSize: string;
  buttonSize?: string;
  smallCta: boolean;
  autoWidth: boolean;
}

export const STREAM_LINK_SMALL_STYLES: StreamLinkStyles = {
  borderRadius: "8px",
  height: "64px",
  paddingX: "24px",
  gap: "32px",
  textSize: "16px",
  buttonSize: undefined,
  smallCta: false,
  autoWidth: false,
};

export const STREAM_LINK_MEDIUM_STYLES: Record<string, StreamLinkStyles> = {
  base: {
    borderRadius: "16px",
    height: "25vw",
    paddingX: "24px",
    gap: "24px",
    textSize: "12px",
    buttonSize: "16px",
    smallCta: true,
    autoWidth: true,
  },
  xs: {
    borderRadius: "16px",
    height: "25vw",
    paddingX: "24px",
    gap: "24px",
    textSize: "12px",
    buttonSize: "16px",
    smallCta: true,
    autoWidth: true,
  },
  sm: {
    borderRadius: "16px",
    height: "15vw",
    paddingX: "24px",
    gap: "40px",
    textSize: "12px",
    buttonSize: "16px",
    smallCta: true,
    autoWidth: true,
  },
  md: {
    borderRadius: "16px",
    height: "8vw",
    paddingX: "20px",
    gap: "24px",
    textSize: "14px",
    buttonSize: "13px",
    smallCta: false,
    autoWidth: false,
  },
  lg: {
    borderRadius: "20px",
    height: "calc((100vw - var(--sidebar-offset, 0px)) * 0.07)",
    paddingX: "40px",
    gap: "40px",
    textSize: "16px",
    buttonSize: "13px",
    smallCta: false,
    autoWidth: false,
  },
  xl: {
    borderRadius: "20px",
    height: "calc((100vw - var(--sidebar-offset, 0px)) * 0.07)",
    paddingX: "40px",
    gap: "80px",
    textSize: "22px",
    buttonSize: "13px",
    smallCta: false,
    autoWidth: false,
  },
  "2xl": {
    borderRadius: "20px",
    height: "calc((100vw - var(--sidebar-offset, 0px)) * 0.07)",
    paddingX: "40px",
    gap: "80px",
    textSize: "22px",
    buttonSize: "13px",
    smallCta: false,
    autoWidth: false,
  },
  "3xl": {
    borderRadius: "32px",
    height: "calc((100vw - var(--sidebar-offset, 0px)) * 0.07)",
    paddingX: "40px",
    gap: "100px",
    textSize: "24px",
    buttonSize: "16px",
    smallCta: false,
    autoWidth: false,
  },
  "4xl": {
    borderRadius: "32px",
    height: "calc((100vw - var(--sidebar-offset, 0px)) * 0.07)",
    paddingX: "40px",
    gap: "100px",
    textSize: "24px",
    buttonSize: "16px",
    smallCta: false,
    autoWidth: false,
  },
};
